export const QA_NAME_PROVENANCE_CHIP = 'rentalPortalProvenanceChip'

export const PROVENANCE_CHIP_BACKGROUND_COLOR = 'var(--color-bg-third)'

export const PROVENANCE_CHIP_TEXT_COLOR = 'var(--secondary-text-color)'

export const PROVENANCE_ENTITY = {
  building: 'Building',
  flat: 'Flat',
}

export const PROVENANCE_FIELD = {
  area: 'area',
  buildingAddress: 'address',
  flatNumber: 'number',
  roomCount: 'room_count',
}

export const PROVENANCE_OWNERSHIP_PAGE_SIZE = 100
